export default __webpack_public_path__ + "static/media/7710f72d73eb80c6c4a2231d6b30f613.png";